"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.object.values");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ButtonVariant = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  TERTIARYWHITE: 'tertiary is-tertiary--white',
  LINK: 'link',
  LINKWHITE: 'link--white',
  BANNER: 'banner'
};
var ButtonSize = {
  SMALL: 'small',
  REGULAR: 'regular'
}; // Please refer to '@icare/core/scss/mixins/_button.mixins.scss' for list of available icons

var IconPosition = {
  BEFORE: 'before',
  AFTER: 'after'
};

var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button() {
    _classCallCheck(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          className = _this$props.className,
          variant = _this$props.variant,
          size = _this$props.size,
          Tag = _this$props.tag,
          children = _this$props.children,
          iconName = _this$props.iconName,
          iconOnly = _this$props.iconOnly,
          iconPosition = _this$props.iconPosition,
          fullWidth = _this$props.fullWidth,
          hasExternalLink = _this$props.hasExternalLink,
          attrs = _objectWithoutProperties(_this$props, ["className", "variant", "size", "tag", "children", "iconName", "iconOnly", "iconPosition", "fullWidth", "hasExternalLink"]);

      var classes = (0, _classnames.default)((_classNames = {
        cta: variant !== Button.Variant.LINK && variant !== Button.Variant.LINKWHITE
      }, _defineProperty(_classNames, "is-".concat(variant), variant !== Button.Variant.LINK && variant !== Button.Variant.LINKWHITE), _defineProperty(_classNames, 'faux-link', variant === Button.Variant.LINK || variant === Button.Variant.LINKWHITE), _defineProperty(_classNames, 'faux-link--white', variant === Button.Variant.LINKWHITE), _defineProperty(_classNames, "is-".concat(size), size !== Button.Size.REGULAR), _defineProperty(_classNames, 'is-full', fullWidth), _defineProperty(_classNames, 'has-icon', !!iconName), _defineProperty(_classNames, 'has-icon--only', !!iconOnly), _defineProperty(_classNames, 'has-icon--before', !!iconName && iconPosition === Button.IconPosition.BEFORE), _defineProperty(_classNames, 'has-icon--external-link', hasExternalLink), _classNames), className);

      if (Tag === 'input') {
        return /*#__PURE__*/_react.default.createElement("input", _extends({
          value: children,
          className: classes
        }, attrs));
      }

      var icon = /*#__PURE__*/_react.default.createElement("span", {
        className: "cta-icon btn-icon-".concat(iconName)
      });

      return /*#__PURE__*/_react.default.createElement(Tag, _extends({
        className: classes
      }, attrs), iconOnly && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "vh"
      }, children), icon), !iconOnly && iconName && iconPosition === Button.IconPosition.BEFORE && icon, !iconOnly && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children), !iconOnly && iconName && iconPosition === Button.IconPosition.AFTER && icon);
    }
  }], [{
    key: "Variant",
    get: function get() {
      return ButtonVariant;
    }
  }, {
    key: "Size",
    get: function get() {
      return ButtonSize;
    }
  }, {
    key: "IconPosition",
    get: function get() {
      return IconPosition;
    }
  }]);

  return Button;
}(_react.default.Component);

Button.defaultProps = {
  className: null,
  children: null,
  tag: 'button',
  variant: Button.Variant.PRIMARY,
  size: Button.Size.REGULAR,
  iconName: null,
  iconOnly: false,
  iconPosition: Button.IconPosition.AFTER,
  fullWidth: false,
  hasExternalLink: false
};
Button.propTypes = {
  className: _propTypes.default.string,
  tag: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element, _propTypes.default.node, _propTypes.default.func]),
  variant: _propTypes.default.oneOf(Object.values(Button.Variant)),
  size: _propTypes.default.oneOf(Object.values(Button.Size)),
  children: _propTypes.default.node,
  iconName: _propTypes.default.string,
  iconOnly: _propTypes.default.bool,
  iconPosition: _propTypes.default.oneOf(Object.values(Button.IconPosition)),
  fullWidth: _propTypes.default.bool,
  hasExternalLink: _propTypes.default.bool
};
var _default = Button;
exports.default = _default;
//# sourceMappingURL=Button.js.map